export default "__VITE_ASSET__DERRMEgP__"